import React, { useRef } from 'react';
import Alarm from 'features/user/pages/clockInClockOut/components/MainV2/Alarm';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import storage from 'utils/sessionStorage';
import RequestAdminLocalPW from 'widgets/RequestAdminLocalPW';
import { useAppDispatch } from 'store/hooks';
import appointmentSelectors from 'features/appointment/services/selectors';
import { APPOINTMENT_LAYOUT } from 'features/appointment/services/constants';
import appointmentActions from 'features/appointment/services/actions';
import home_icon from './icons/home.svg';
import gallery_icon from './icons/gallery.svg';
import gallery_active_icon from './icons/gallery-active.svg';
import list_icon from './icons/list.svg';
import list_active_icon from './icons/list-active.svg';
import break_icon from './icons/break.svg';
import book_by_apt_icon from './icons/book_by_apt.svg';
import book_by_sers_icon from './icons/book_by_sers.svg';
import book_by_staff_icon from './icons/book_by_staff.svg';
import { calcColTime } from '../../Actions';
import { quickBookingRef } from '../TableView/Body/Modal/QuickBooking';
import ModalReferAnybody, {
  useModalReferAnybodyRef,
} from 'features/appointment/pages/AppointmentsPage/components/Calendar/TableView/Body/Modal/NewAppointmentV2/v2/ModalReferAnybody';
import shopSelectors from 'services/shop/selectors';
import { verifyPinCode } from 'widgets/RequestAdminLocalPW/Callback';
import { quickBookingV2Ref } from '../TableView/Body/Modal/QuickBookingV2';
import { newAppointmentVersionV2Ref } from 'features/appointment/pages/AppointmentsPage/components/Calendar/TableView/Body/Modal/NewAppointmentV2/v2';
import { blockHoursRef } from 'features/appointment/pages/AppointmentsPage/components/Calendar/TableView/Body/Modal/BlockHours';
import refresh_icon from './icons/refresh_ic.svg';
import logout_icon from './icons/logout_ic.svg';
import ButtonSetting from './Buttons/ButtonSetting';
import ModalConfirm, { useModalConfirmRef } from 'components/Modal/ModalConfirm';
import cashierActions from 'features/cashier/services/actions';
import authActions from 'features/auth/services/actions';
import useTabletApp from 'hooks/useTabletApp';
import caller_id_icon from './icons/caller-id.svg';
import ModalCallerIdHistory from 'features/user/pages/clockInClockOut/components/MainV2/ModalCallerIdHistory';
import PermissionManager from 'widgets/PermissionVerify';
import BookingV4 from '../../BookingV4';
import guide_booking_icon from './icons/guide_booking.svg';

const AppointmentCalendarHeaderV2 = () => {
  const tabletApp = useTabletApp();
  const onWebViewAppBackToHome = () => tabletApp.backtoHome();

  return (
    <Container id='calendar-header'>
      <LeftBox>
        <div className='station-box'>
          <span>Station {storage.station_number.get()}</span>
        </div>
        <Alarm />
      </LeftBox>
      <RightBox>
        {tabletApp?.enable ?
          <ButtonNavPin onClickOverride={onWebViewAppBackToHome} required={false} title='Home' src={home_icon} alt='home_icon' path='/' /> :
          <ButtonNavPin required={false} title='Home' src={home_icon} alt='home_icon' path='/' />}
        <ButtonLayouts />
        {/* <ButtonDateOffs /> */}
        <ButtonQuickBookingV2 />
        <ButtonQuickBooking />
        <ButtonNewAppointment />
        {/* <ButtonTimeTracker title='Tracking' /> */}
        <BookingV4Button />
        <ButtonCallerId />
        <ButtonBlockHour />
        {/* <ButtonExpandTime /> */}
        <ButtonSetting />
        <ButtonRefresh />
        {!tabletApp.enable && <ButtonLogout />}
      </RightBox>
    </Container>
  );
};

export default AppointmentCalendarHeaderV2;

const ButtonRefresh = () => {
  const dispatch = useAppDispatch();

  return (
    <ButtonUI
      title={'Refresh'}
      src={refresh_icon}
      alt={'refresh_icon'}
      onClick={() => {
        dispatch(appointmentActions.initData());
        dispatch(appointmentActions.setStaffFilterIds([]));
      }}
    />
  );
};

const ButtonLogout = () => {
  const modal = useModalConfirmRef();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const logout = () => {
    dispatch(cashierActions.checkCashierWillUnmount());
    modal.current?.open('Are you about to logout the system?', () => {
      dispatch(authActions.ownerLogout());
      navigate('/sign-in');
    });
  };

  return (
    <>
      <ButtonUI title={'Logout'} src={logout_icon} alt={'logout_icon'} onClick={logout} />
      <ModalConfirm ref={modal} okTitle='Yes' cancelTitle='No' />
    </>
  );
};

const ButtonNewAppointment = () => {
  const colTime = calcColTime();
  const modalReferAnybodyRef = useModalReferAnybodyRef();
  const allSetting = shopSelectors.data.allSetting();
  const newAppointment = () => {
    newAppointmentVersionV2Ref.current?.open({
      colTime: colTime(),
      newApt: true,
      verifiedPinCode: true,
    });
  };

  const onClickNewApt = async () => {
    const callback = () => {
      modalReferAnybodyRef.current?.open();
    };

    if (allSetting?.enableVerifyBooking) {
      const result = await PermissionManager.verify(PermissionManager.PERMISSIONS.APPOINTMENT_BOOKING);
      if (result !== null) {
        if (!result || result?.skip) return callback();
        if (!result.verifyData) return;
        callback();
      } else {
        verifyPinCode(() => callback(), true);
      }
      return;
    }

    return callback();
  };

  return (
    <>
      <ButtonUI
        title={'Book By Appt'}
        src={book_by_apt_icon}
        alt={'new_appt_icon'}
        onClick={onClickNewApt}
      />
      <ModalReferAnybody ref={modalReferAnybodyRef} onConfirm={newAppointment} />
    </>
  );
};

const ButtonQuickBookingV2 = () => {
  const staffListStore = appointmentSelectors.getListStaffAvailableBooking();

  const newQuickBooking = () => {
    const anybody = staffListStore.find(o => o.anyBody);
    quickBookingV2Ref.current?.open('', anybody?.id);
  };

  return (
    <ButtonUI
      title={'Book By Sers'}
      src={book_by_sers_icon}
      alt={'quick_booking_icon'}
      onClick={newQuickBooking}
    />
  );
};
const ButtonQuickBooking = () => {
  const colTime = calcColTime();
  const newQuickBooking = () => {
    quickBookingRef.current?.open(colTime() || '');
  };

  return (
    <ButtonUI
      title={'Book By Staffs'}
      src={book_by_staff_icon}
      alt={'quick_booking_icon'}
      onClick={newQuickBooking}
    />
  );
};

// const ButtonBreakTime = () => {
//   const colTime = calcColTime();
//   const dispatch = useAppDispatch();

//   const newBreakTime = () => {
//     dispatch(
//       appointmentActions.setNewBreakTimeDraftData({
//         colTime: colTime(),
//       })
//     );
//   };

//   return <ButtonUI title={'On Break'} src={break_icon} alt={'break_icon'} onClick={newBreakTime} />;
// };

const BookingV4Button = () => {
  const onOpen = () => BookingV4.toggle();
  return (
    <>
      <ButtonUI
        title={'Aloha Booking'}
        src={guide_booking_icon}
        alt={'guide_booking_icon'}
        onClick={onOpen}
      />
    </>
  );
};

const ButtonCallerId = () => {
  const ref = useRef<{ open: () => void }>(null);
  const onOpen = () => ref.current?.open();
  return (
    <>
      <ButtonUI
        title={'Caller ID'}
        src={caller_id_icon}
        alt={'caller_id_icon'}
        onClick={onOpen}
      />
      <ModalCallerIdHistory ref={ref} />
    </>
  );
};

const ButtonBlockHour = () => {
  const colTime = calcColTime();
  const newBlockHour = () =>
    blockHoursRef.current?.open({ colTime: colTime() });

  return (
    <ButtonUI title={'Time Off'} src={break_icon} alt={'block_hour_icon'} onClick={newBlockHour} />
  );
};

// const ButtonDateOffs = () => {
//   const [open, setOpen] = useState(false);
//   const dispatch = useAppDispatch();
//   const params = appointmentSelectors.getParams();
//   const handleOpen = () => {
//     setOpen(true);
//     dispatch(
//       appointmentActions.getListStaffsOff.fetch({
//         startTime: params?.startTime || '',
//         endTime: params?.endTime || '',
//       })
//     );
//   };
//   return (
//     <>
//       <ButtonUI title={'Date Off'} src={date_off_icon} alt={'date_off_icon'} onClick={handleOpen} />
//       <ModalDateOffs v2 setOpen={setOpen} open={open} />
//     </>
//   );
// };

const ButtonLayouts = () => {
  const dispatch = useAppDispatch();
  const value = appointmentSelectors.getAppointmentLayout();
  const setValue = (val: APPOINTMENT_LAYOUT) => () => {
    dispatch(appointmentActions.setAppointmentLayout(val));
  };
  return (
    <>
      <ButtonUI
        title={'Gallery View'}
        src={value === APPOINTMENT_LAYOUT.CALENDAR ? gallery_active_icon : gallery_icon}
        alt={'gallery_icon'}
        className={value === APPOINTMENT_LAYOUT.CALENDAR ? 'active' : ''}
        onClick={setValue(APPOINTMENT_LAYOUT.CALENDAR)}
      />
      <ButtonUI
        title={'List View'}
        src={value === APPOINTMENT_LAYOUT.LIST ? list_active_icon : list_icon}
        alt={'list_icon'}
        className={value === APPOINTMENT_LAYOUT.LIST ? 'active' : ''}
        onClick={setValue(APPOINTMENT_LAYOUT.LIST)}
      />
    </>
  );
};

const ButtonNavPin = ({
  src,
  alt,
  path,
  required = true,
  title,
  onClickOverride,
}: {
  title: string;
  src: any;
  alt: string;
  path: string;
  required?: boolean;
  onClickOverride?: () => void;
}) => {
  const navigate = useNavigate();
  const [visiblePW, setVisiblePW] = React.useState(false);

  const onOpen = () => {
    if (required) return setVisiblePW(true);
    navigate(`/store/${storage.shop_id.get()}${path}`);
  };

  const onVerifyAdminSuccess = () => {
    if (visiblePW) navigate(`/store/${storage.shop_id.get()}${path}`);
    setVisiblePW(false);
  };

  return (
    <>
      <ButtonUI title={title} src={src} alt={alt} onClick={onClickOverride || onOpen} />
      {!!visiblePW && (
        <RequestAdminLocalPW
          v2
          onlyAdmin
          visible
          onCorrect={onVerifyAdminSuccess}
          onClose={() => setVisiblePW(false)}
        />
      )}
    </>
  );
};
const ButtonUI = ({
  className = '',
  onClick,
  src,
  alt,
  title,
}: {
  className?: string;
  title?: string;
  src?: any;
  alt?: string;
  onClick?: () => void;
}) => {
  return (
    <button className={'btn ' + className} onClick={onClick}>
      <img src={src} alt={alt} className='icon-action' />
      <span>{title}</span>
    </button>
  );
};
const Container = styled.div`
  display: flex;
  align-self: stretch;
  background: #fff;
  &.calendar-header-hidden {
    display: none;
  }
`;

const LeftBox = styled.div`
  display: flex;
  background: #232f3e;
  align-items: center;
  justify-content: space-between;
  padding: 24px;
  gap: 24px;
  margin-bottom: 8px;
  min-width: 800px;
  .station-box {
    display: flex;
    height: 48px;
    padding: 0px 16px;
    justify-content: center;
    align-items: center;
    gap: 10px;
    border-radius: 5px;
    background: #fff;
    span {
      color: #1d2129;
      text-align: center;
      font-family: Poppins;
      font-size: 22px;
      font-style: normal;
      font-weight: 600;
      line-height: normal;
      text-transform: uppercase;
    }
  }

  .today-label {
    display: flex;
    .digital {
      display: inline-flex;
      align-items: center;
    }
    .digital p {
      color: #fbe696;
      font-size: 55px;
    }
  }
  .clock .hour {
    line-height: unset;
  }
  .clock .hour .ampm,
  .clock .hour .digital :last-child {
    color: #fbe696;
    font-weight: 600;
  }
`;

const RightBox = styled.div`
  display: flex;
  padding: 0;
  padding-left: 8px;
  padding-bottom: 8px;
  align-items: center;
  flex-shrink: 0;
  flex: 1;
  background: #fff;
  button.btn {
    display: flex;
    padding: 8px 10px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 2px;
    flex: 1 0 0;
    align-self: stretch;
    background: #fcfcfd;
    box-shadow: 0px 2px 4px 0px rgba(44, 35, 66, 0.4), 0px 4px 8px -3px rgba(45, 35, 66, 0.3),
      0px -3px 0px 0px #d6d6e7 inset;
    img.icon-action {
      display: flex;
      width: 80px;
      height: 80px;
      justify-content: center;
      align-items: center;
    }
    span {
      color: #1d2129;
      text-align: center;
      font-family: Poppins;
      font-size: 16px;
      font-style: normal;
      font-weight: 600;
      line-height: normal;
    }
    &:hover {
      background: #eee;
    }

    &.active {
      background: #c84b31;
      span {
        color: #fff;
      }
    }
  }
`;
